import { FC, useEffect, useState } from "react";
import { Box, Button, Chip, Typography, useMediaQuery, useTheme } from "@material-ui/core";

import ExpireLink from "../../assets/images/ExpireLinkIcon.svg";

import { PoolButtonProps } from "../../interfaces";
import usePoolButton from "../../hooks/pool/usePoolButton";
import PoolCardStyle from "./PoolsStyle";
import CountdownTimer from "./CountdownTimer";

const Expire = () => {
    return <img src={ExpireLink} className="img-fluid imageAlign" />;
};

const PoolButton: FC<PoolButtonProps> = ({
    poolId,
    poolStatus,
    dealPage,
    handleClick,
    whitelisted,
    whitelistedData,
    quizStatus,
    kycDeadlineDate,
    invest,
    pledgeStartDate,
    pledgeEndDate,
    contributionStartDate,
    contributionEndDate,
    fullWidth = false,
    isGiveaway,
    userTier,
    isExternalProject = false,
}) => {

    // We show timer for contribution deadline, whitelist deadline
    // and kyc deadline

    const classes = PoolCardStyle();

    const theme = useTheme();

    const [duration, setDuration] = useState<number>(0); 
    const [showCounter, toggleCounter] = useState(false);
    const [deadlineDate, setDeadlineDate] = useState<Date>();
    const [localDisable, toggleLocalDisable] = useState<boolean>(false);
    const now = new Date().getTime();

    useEffect(() => {
        if (poolStatus === 'upcoming' && pledgeStartDate) {
            setDuration((new Date(pledgeStartDate).getTime() - now) / 1000)
            toggleCounter(true)
            setDeadlineDate(pledgeStartDate)
        }
        if (poolStatus === 'whitelist_open' && pledgeEndDate) {
            setDuration((new Date(pledgeEndDate).getTime() - now) / 1000)
            toggleCounter(true)
            setDeadlineDate(pledgeEndDate)
        }
        if (poolStatus === 'whitelist_closed' && contributionStartDate) {
            toggleLocalDisable(true);
            setDuration((new Date(contributionStartDate).getTime() - now) / 1000)
            toggleCounter(true)
            setDeadlineDate(contributionStartDate)
        }
        if (poolStatus === 'ongoing' && contributionEndDate) {
            setDuration((new Date(contributionEndDate).getTime() - now) /1000)
            toggleCounter(true)
            setDeadlineDate(contributionEndDate)
        }
    }, [])

    const { buttonText, disabled } = usePoolButton({poolId, poolStatus, quizStatus, whitelistedData, whitelisted, kycDeadlineDate, invest, deadlineDate, dealPage, showTimer:duration > 0, isGiveaway, userTier, isExternalProject});

    return (
            <Box
                style={{
                    width: fullWidth ? "100%" : "auto",
                }}          
            >
                <div
                    className={
                        (disabled || localDisable)
                        ? "cursor-not-allowed"
                        : "pointer"
                    }
                >
                    <Button
                        variant="contained"
                        className={classes.actionButton}
                        disabled={disabled || localDisable}
                        color="primary"
                        onClick={handleClick}
                        fullWidth={true}
                        endIcon={
                            showCounter && dealPage && !disabled && duration > 0 && (
                                <Chip
                                    color="secondary"
                                    label={<CountdownTimer initialTime={duration} />}
                                    className={classes.countdown}
                                    size="small"
                                />
                            )
                        }
                    >
                        { buttonText }
                    </Button>
                </div>
            </Box>
    )
}

export default PoolButton